import { z } from 'zod'

// ProblemResponse was removed from the regenerated OpenAPI spec — failures are now modelled as
// discriminated outcome variants with their own typed *ProblemDetails. ApiError is the sole consumer
// of this shape, so the schema lives here rather than in the spec-anchored api-schemas.ts (same
// de-anchoring precedent as UserSchema). See ISS-7852 / ISS-8079.
const ProblemResponseSchema = z.object({
  title: z.string(),
  detail: z.string(),
})

export class ApiError extends Error {
  constructor(
    public status: number,
    bodyAsText?: string | object,
    public path?: string
  ) {
    super(`API request failed with status ${status}`)
    this.name = 'ApiError'
    this.status = status

    if (bodyAsText === undefined || bodyAsText === null) {
      return
    }

    if (typeof bodyAsText === 'object') {
      this.bodyAsText = JSON.stringify(bodyAsText, undefined, 2)
      this.parseProblemJson(bodyAsText)
      return
    }

    if (typeof bodyAsText === 'string') {
      this.bodyAsText = bodyAsText
      this.parseProblemJsonFromText(bodyAsText)
      return
    }

    console.error(
      `ApiError constructor expected bodyAsText to be a string or object but was a ${typeof bodyAsText}: ${bodyAsText}`
    )
  }

  public bodyAsText?: string
  public problemTitle?: string
  public problemDetail?: string

  private parseProblemJsonFromText(text: string) {
    try {
      const parsed: unknown = JSON.parse(text)
      if (typeof parsed === 'object' && parsed !== null) {
        this.parseProblemJson(parsed)
      }
    } catch {
      // Not valid JSON — leave problemTitle/problemDetail undefined
    }
  }

  private parseProblemJson(body: object) {
    const result = ProblemResponseSchema.safeParse(body)
    if (result.success) {
      this.problemTitle = result.data.title
      this.problemDetail = result.data.detail
    }
  }
}
